import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

import { ConfigurationSecurity } from "@/model/data/security/ConfigurationSecurity";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { ApiGenericResponse } from "../ApiGenericResponse";
const ENDPOINT = "/security/installation/template/export";

export class ExportTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ExportTemplateReqData;

    constructor(payload: ExportTemplateReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class ExportTemplateReqData {
    installationName: string;
    templateName: string;
    configurationToExport: ConfigurationSecurity;
    templateContent: TemplateContentEnum;
}
